const FILTERS = {
    vrops: {
        vrops_release: {
            title: 'Operations Release',
            icon: 'server.png'
        },
        managementpack_version: {
            title: 'Management Pack Version',
            icon: 'os_kernel.png'
        },
        array_customer_version: {
            title: 'Storage',
            icon: 'switch.png'
        },
        protocol: {
            title: 'Protocol',
            icon: 'os_kernel.png'
        }
    }
}
export default FILTERS;